import { BehaviorSubject, Observable, catchError, finalize, of } from 'rxjs';
import { ProtocolQAudit, ProtocolQAuditFilter } from './protocol';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { ProtocolQService } from '../services/protocolQ.service';

export class ProtocolAirAuditDataSource implements DataSource<ProtocolQAudit> {

    private protocolsSubject = new BehaviorSubject<ProtocolQAudit[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    private totalSubject = new BehaviorSubject<number>(0);

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public loading$ = this.loadingSubject.asObservable();
    // eslint-disable-next-line @typescript-eslint/member-ordering
    public totalItems$ = this.totalSubject.asObservable();

    constructor(private service: ProtocolQService) { }

    connect(_collectionViewer: CollectionViewer): Observable<ProtocolQAudit[]> {
        return this.protocolsSubject.asObservable();
    }

    disconnect(_collectionViewer: CollectionViewer): void {
        this.protocolsSubject.complete();
        this.loadingSubject.complete();
        this.totalSubject.complete();
    }

    loadProtocolAudit(id: number, filter = new ProtocolQAuditFilter()): void {

        this.loadingSubject.next(true);

        this.service.getAudit(id, filter).pipe(
            catchError(() => of([])),
            finalize(() => this.loadingSubject.next(false))
        ).subscribe(data => {
            if (data && data.content) {
                this.protocolsSubject.next(data.content as ProtocolQAudit[]);
                this.totalSubject.next(data.totalElements as number);
            } else if (data) {
                this.protocolsSubject.next(data as ProtocolQAudit[]);
                this.totalSubject.next(data.length as number);
            } else {
                this.protocolsSubject.next([]);
                this.totalSubject.next(0);
            }
        });
    }
}
